/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Backstage_HomeInputs */

const en_scene_backstage_home = /** @type {(inputs: Scene_Backstage_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What to do now`)
};

/**
* | output |
* | --- |
* | "What to do now" |
*
* @param {Scene_Backstage_HomeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_backstage_home = /** @type {((inputs?: Scene_Backstage_HomeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Backstage_HomeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_backstage_home(inputs)
});